<template>
  <Flex
    v-if="appointment && appointment.parts && appointment.parts.length"
    direction="column"
    v-test="'service-list'"
  >
    <Parts
      :data="appointment.parts"
      :endBuffer="appointment.endBuffer"
    />

    <div v-if="appointment.treatwell">
      <BaseAlert
        icon="treatwell"
        size="s"
        inline
        :color="appointment.paidThroughTreatwell ? 'success' : 'warning'"
        :text="twIconTooltip"
        v-test="'treatwell-logo'"
      />
    </div>
    <AppointmentDiscountCode
      :discountCode="appointment.discountCode"
      size="s"
      v-test="'appointment-discount-code'"
    />
    <BaseAlert
      v-if="!appointment.discountCode && appointment.priceAdjustment"
      color="info"
      :text="
        $t(
          appointment.priceAdjustment.adjustmentType === 'PERCENTAGE_INCREASE'
            ? 'dynamic_pricing.notification_increase'
            : 'dynamic_pricing.notification_discount',
          { amount: appointment.priceAdjustment.amount + '%' }
        )
      "
      icon="percentage"
      size="s"
      inline
      v-test="'appointment-price-adjustment'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import AppointmentDiscountCode from '@/components/AppointmentDiscountCode.vue';
import Flex from '@/components/layout/Flex.vue';
import Parts from './Parts.vue';

const props = defineProps<{
  appointment: any;
}>();

const { t } = useI18n();

const twIconTooltip = computed(() => {
  const reference = t('appointment.tw_order_reference', {
    number: props.appointment.treatwellOrder?.reference,
  });

  if (props.appointment.paidThroughTreatwell) {
    return `${t('appointment.paid_online')} - ${reference}`;
  } else {
    return `${t('appointment.outstanding_payment')} - ${reference}`;
  }
});
</script>
